<template>
  <MemberTree />
</template>
<script>
import MemberTree from '@/components/members/MemberTree.vue'
export default {
  name: 'MemberView',
  components: {
    MemberTree
  }
}
</script>
<style lang="scss" scoped></style>
